const END_POINTS = {
    API_BASE_URL: 'https://api.proglint.com',
}

export default END_POINTS;